import FontLoader from './fontLoader';


export default FontLoader;

